import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DsIconModule } from '@skyeng/libs/shared/ui-kit-v2/icon';
import { DsDefaultIconsModule } from '@skyeng/libs/shared/ui-kit-v2/icon/icons';

export type LaboratoryNoticeType = 'info' | 'positive' | 'warning' | 'negative';

/**
 * Плашка-уведомление В ПОТОКЕ страницы: объясняет состояние экрана рядом с тем, к чему
 * относится. Не путать с `ds-notification-*` — там плавающий тост поверх интерфейса,
 * который живёт секунды и адресован действию, а не месту.
 *
 * Роль намеренно не выставляется: нужна ли плашке live-region, знает потребитель, а не
 * её внешний вид. Кому нужно — ставит `role` на сам `lab-notice`.
 */
@Component({
  selector: 'lab-notice',
  imports: [DsIconModule, DsDefaultIconsModule],
  template: `
    <div
      class="root"
      [class.-info]="type() === 'info'"
      [class.-positive]="type() === 'positive'"
      [class.-warning]="type() === 'warning'"
      [class.-negative]="type() === 'negative'"
    >
      <!-- Иконка — второй, не-цветовой признак серьёзности: в greyscale и при дальтонизме
           заливка одна на всех, и различать типы больше нечем. -->
      <span class="icon" aria-hidden="true">
        @switch (type()) {
          @case ('positive') {
            <ds-icon-check-in-circle icon size="s"></ds-icon-check-in-circle>
          }
          @case ('warning') {
            <ds-icon-attention-in-triangle icon size="s"></ds-icon-attention-in-triangle>
          }
          @case ('negative') {
            <ds-icon-close-in-circle icon size="s"></ds-icon-close-in-circle>
          }
          @default {
            <ds-icon-info icon size="s"></ds-icon-info>
          }
        }
      </span>

      <span class="text"><ng-content /></span>

      <!-- Место под действие или бейдж: без него структура из потребителя уезжает
           разделителем в середину предложения. -->
      <span class="action"><ng-content select="[labNoticeAction]" /></span>
    </div>
  `,
  styleUrls: ['./notice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LaboratoryNoticeComponent {
  readonly type = input<LaboratoryNoticeType>('info');
}
